module.exports = __webpack_public_path__ + "img/A.7299c007.png";